import React from 'react'
import InputField from '../DynamicLabelInput'
import styles from './style.module.scss'
import { Dropdown } from 'antd'

interface LabelItem {
  key: string
  label: string
}

interface SectionProps {
  editData: any
  propName: string
  labelList: LabelItem[] | null
  getDropDownInfoList?: ((label: string | null) => LabelItem[]) | null
  icon: string
  addButtonLabel: string
  canDelete: (index: number) => boolean
  onFieldChange: (propName: string, index: number, value: any) => void
  onLabelChange: (propName: string, index: number, label: string) => void
  onAddItem: (propName: string, label: string) => void
  onDelete: (propName: string, index: number) => void
  inputFieldsRender?: ((index: number) => React.ReactNode) | null
  useCustomLabelRender?: ((datas: any[]) => React.ReactNode) | null
}

const Section = ({
  editData,
  propName,
  labelList,
  getDropDownInfoList = null,
  icon,
  addButtonLabel,
  canDelete,
  onFieldChange,
  onLabelChange,
  onAddItem,
  onDelete,
  inputFieldsRender = null,
  useCustomLabelRender = null,
}: SectionProps) => {
  const datas = editData[propName]

  const getCustomGroupList = () => {
    if (!datas || datas.length === 0) {
      return null
    }

    return <div className={styles.groupList}>{useCustomLabelRender!(datas)}</div>
  }

  let dropdownInfoList: LabelItem[] | null = null
  if (getDropDownInfoList) {
    dropdownInfoList = getDropDownInfoList(null)
  } else {
    dropdownInfoList = labelList
  }

  return (
    <div className={styles.container}>
      <div className={styles.groups}>
        <div className={styles.iconWrapper}>
          <img src={icon} alt={propName + 'icon'} />
        </div>
        <div className={styles.groupListWrapper}>
          {useCustomLabelRender === null
            ? datas &&
              datas.length > 0 && (
                <div className={styles.groupList}>
                  {datas.map((data: any, index: number) => (
                    <InputField
                      key={propName + index}
                      id={propName}
                      index={index}
                      label={data.type || ''}
                      value={data.value}
                      labelList={labelList || []}
                      getDropDownInfoList={getDropDownInfoList}
                      canDelete={canDelete(index)}
                      onValueChange={(_, value) => onFieldChange(propName, index, value)}
                      onLabelChange={(_, label) => onLabelChange(propName, index, label)}
                      onDelete={() => onDelete(propName, index)}
                      inputFieldsRender={inputFieldsRender}
                    />
                  ))}
                </div>
              )
            : getCustomGroupList()}
          {dropdownInfoList !== null &&
            (dropdownInfoList.length > 0 ? (
              <Dropdown
                menu={{
                  items: dropdownInfoList.map((label) => ({
                    key: label.key,
                    label: label.label,
                    onClick: () => onAddItem(propName, label.key),
                  })),
                }}
                trigger={['click']}
                overlayClassName="contextMenu"
              >
                <div className={styles.addButton}>{addButtonLabel}</div>
              </Dropdown>
            ) : (
              <div className={styles.addButton} onClick={() => onAddItem(propName, '')}>
                {addButtonLabel}
              </div>
            ))}
        </div>
      </div>
    </div>
  )
}

export default Section
